// Copyright (c) StrangeBee 2023

import React, { ReactElement } from 'react';
import { useLocalMessage } from '@Helpers/locale';
import useValidateForm from '@Hooks/useValidateForm';
import THDrawer from '@Molecules/THDrawer/THDrawer';
import { CaseBulkCaseTemplateForm } from './CaseBulkCaseTemplateForm';
import { BulkCaseTemplateParams } from 'thehive-sdk';

interface CaseBulkEditManageProps {
    triggerElem: ReactElement;
    onEdit: (values: Partial<BulkCaseTemplateParams>) => void;
    organisation: string;
}

const CaseBulkEditManage = ({ triggerElem, onEdit, organisation = '' }: CaseBulkEditManageProps): ReactElement => {
    const i = useLocalMessage();
    const { form, isValid, onFormValuesChange, fieldsTouched, setFieldsTouched } = useValidateForm();

    const onFinish = (values: Partial<BulkCaseTemplateParams>): void => {
        onEdit(values);
        form.resetFields();
        setFieldsTouched(false);
    };

    return (
        <THDrawer
            title={i('case.bulk-caseTemplate.drawer.title')}
            triggerElem={triggerElem}
            afterVisibleChange={() => form.resetFields()}
            className="drawer-form"
            disableClose={fieldsTouched}
        >
            {(toggleDrawer) => (
                <CaseBulkCaseTemplateForm
                    onFinish={(values) => {
                        onFinish(values);
                        toggleDrawer();
                    }}
                    organisation={organisation}
                    form={form}
                    onChange={() => {
                        onFormValuesChange();
                        setFieldsTouched(true);
                    }}
                    isValid={isValid && fieldsTouched}
                    onCancel={() => {
                        form.resetFields();
                        toggleDrawer();
                        setFieldsTouched(false);
                    }}
                />
            )}
        </THDrawer>
    );
};

export default CaseBulkEditManage;
